import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/**
 * fc-lineçº¿æ¡
 * 
 * åºéåå®¹çåå²çº¿ã 
 * 
 * å¯¹ä¸åç« èçææ¬æ®µè½è¿è¡åå²ã
 * 
 * å¯¹è¡åæå­/é¾æ¥è¿è¡åå²ï¼ä¾å¦è¡¨æ ¼çæä½åã
 * 
 */
@Component({
    selector: 'fc-line',
    template: `
    <nz-divider [nzText]="fcLabel" [nzDashed]="_dashed" [nzType]="fcDirection" *ngIf="fcIcon===undefined" [nzOrientation]="fcPosition"></nz-divider>
    <nz-divider [nzDashed]="_dashed" [nzType]="fcDirection" fcLeftIcon="_leftIcon" [nzText]="text" fcLabel="fcLabel" *ngIf="fcIcon!==undefined && fcLeftIcon==='Y'">
        <ng-template #text> <i class="icon iconfont {{fcIcon}}" *ngIf="fcIcon!==undefined"></i> {{fcLabel}}</ng-template>
    </nz-divider>
    <nz-divider [nzDashed]="_dashed" [nzType]="fcDirection" fcRightIcon="_rightIcon" [nzText]="text" fcLabel="fcLabel" 
    *ngIf="fcIcon!==undefined &&fcRightIcon==='Y'&&fcDashed===undefined">
        <ng-template #text>{{fcLabel}} <i class="icon iconfont {{fcIcon}}" *ngIf="fcIcon!==undefined"></i></ng-template>
    </nz-divider>
    <nz-divider [nzDashed]="_dashed" [nzType]="fcDirection" fcRightIcon="_rightIcon" [nzText]="text" fcLabel="fcLabel" 
     *ngIf="fcIcon!==undefined &&fcRightIcon==='Y'&&fcDashed==='Y'">
        <ng-template #text>{{fcLabel}} <i class="icon iconfont {{fcIcon}}" *ngIf="fcIcon!==undefined"></i></ng-template>
    </nz-divider>
    `,
    styles: [`
    `]
})
export class FclineComponent extends FcinputComponent {
     /** é»è®¤æ é¢æ¹å horizontal vertical*/
    @Input()
    fcDirection: string;
     /** èçº¿*/
    @Input()
    fcDashed: string;
    _dashed :boolean = false; 
     /** æå­*/
    @Input()
    fcLabel: string;
     /** æå­ä½ç½®*/
    @Input()
    fcPosition: string;
     /** å·¦ä¾§å¾æ */
    @Input()
    fcLeftIcon: string;
    _leftIcon:boolean=true;
     /** å³ä¾§å¾æ */
    @Input()
    fcRightIcon: string;
    _rightIcon:boolean=false;
     /**å¾æ */
    @Input()
    fcIcon: string;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-line');
        if (this.fcDirection === undefined) {
            this.fcDirection = "horizontal";
        }
        if (this.fcPosition === undefined) {
            this.fcPosition = "center";
        }
        if (this.fcLeftIcon === undefined) {
            this._leftIcon = true;
        }
    }
    _afterParentInit(){
        if(this.fcDashed === 'Y'){
            this._dashed = true
        }else{
            this._dashed = false;
        }
        if(this.fcLeftIcon === 'Y'){
            this._leftIcon = true
        }else{
            this._leftIcon = false;
        }
        if(this.fcRightIcon === 'Y'){
            this._rightIcon = true;
        }else{
            this._rightIcon = false;
        }
    }
}